import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  cursor: pointer;
  span {
    display: flex;
    align-items: center;
  }
`;
